import React, { useContext, useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './WebsiteService.module.css';

const cx = classNames.bind(styles);

function WebsiteService() {
  const [isVisible, setIsVisible] = useState(false);

  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      setIsVisible(true);
      const children = Array.from(ref.current.children);
      children.forEach((child, index) => {
        setTimeout(() => {
          if (child) child.classList.add('slide-in');
        }, index * 200);
      });
    }
  }, []);

  return (
    <div className={cx('websiteservice-page')}>
      {/* Hero Section */}
      <section className={cx('hero-section')}>
        <div className={cx('hero-content')}>
          <h1 className={cx('hero-title')}>Dịch Vụ Thiết Kế Website Chuyên Nghiệp</h1>
          <p className={cx('hero-description')}>
            Chúng tôi mang đến giải pháp website hiện đại, tối ưu hóa cho doanh nghiệp của bạn. 
            Từ ý tưởng đến bàn giao, mọi thứ đều được chăm chút để giúp bạn nổi bật trên không gian số.
          </p>
          <a href="/contact" className={cx('cta-button')}>
            Liên Hệ Ngay
          </a>
        </div>
        <div className={cx('hero-image')}>
          <img 
            src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" 
            alt="Website Design Hero" 
          />
        </div>
      </section>

      {/* Description Section */}
      <section ref={ref} className={cx('description-section')}>
        <div className={cx('content-wrapper')}>
          <h2 className={cx('section-title')}>1. Mô tả dịch vụ</h2>
          <p className={cx('section-intro')}>
            Chúng tôi cung cấp dịch vụ thiết kế website trọn gói, bao gồm:
          </p>
          <ul className={cx('feature-list')}>
            <li>Tư vấn giao diện và cấu trúc website phù hợp với lĩnh vực hoạt động của khách hàng.</li>
            <li>Thiết kế UI/UX hiện đại, tối ưu trải nghiệm người dùng.</li>
            <li>Lập trình website theo yêu cầu (giới thiệu, bán hàng, tin tức, blog, v.v.).</li>
            <li>Tích hợp đầy đủ các tính năng cần thiết: quản lý sản phẩm, đơn hàng, tin tức, form liên hệ, kết nối mạng xã hội,…</li>
            <li>Hỗ trợ SEO cơ bản, tối ưu tốc độ tải trang.</li>
            <li>Bảo hành, hỗ trợ kỹ thuật sau bàn giao.</li>
          </ul>
        </div>
      </section>

      {/* Process Section */}
      <section className={cx('process-section')}>
        <div className={cx('content-wrapper')}>
          <h2 className={cx('section-title')}>2. Quy trình thực hiện và thanh toán</h2>
          <div className={cx('table-wrapper')}>
            <table className={cx('process-table')}>
              <thead>
                <tr>
                  <th>Giai đoạn</th>
                  <th>Nội dung công việc</th>
                  <th>Tỷ lệ thanh toán</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Bước 1 – Xác nhận dự án</td>
                  <td>Hai bên thống nhất yêu cầu và báo giá. Khách hàng thanh toán 50% giá trị hợp đồng để bắt đầu thực hiện.</td>
                  <td>50%</td>
                </tr>
                <tr>
                  <td>Bước 2 – Hoàn thiện bản demo</td>
                  <td>Bên thiết kế hoàn thành bản demo website (giao diện và tính năng cơ bản) để khách hàng xem và phản hồi. Sau khi duyệt, khách hàng thanh toán 30% giá trị hợp đồng.</td>
                  <td>30%</td>
                </tr>
                <tr>
                  <td>Bước 3 – Bàn giao hoàn chỉnh</td>
                  <td>Hoàn thiện website theo phản hồi cuối cùng, kiểm thử và bàn giao toàn bộ mã nguồn, hướng dẫn sử dụng. Khách hàng thanh toán phần còn lại 20% giá trị hợp đồng.</td>
                  <td>20%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Commitment Section */}
      <section className={cx('commitment-section')}>
        <div className={cx('content-wrapper')}>
          <h2 className={cx('section-title')}>3. Cam kết</h2>
          <ul className={cx('feature-list')}>
            <li>Giao diện đẹp, chuẩn thương hiệu.</li>
            <li>Website tương thích tốt trên điện thoại và máy tính.</li>
            <li>Bảo mật cao, dễ quản trị.</li>
            <li>Bảo hành miễn phí trong thời gian quy định sau bàn giao.</li>
          </ul>
        </div>
      </section>

      {/* CTA Section */}
      <section className={cx('cta-section')}>
        <div className={cx('content-wrapper')}>
          <h2 className={cx('cta-title')}>Sẵn Sàng Bắt Đầu Dự Án Của Bạn?</h2>
          <p className={cx('cta-description')}>
            Chúng tôi cam kết hoàn thành đúng hạn và hỗ trợ bảo trì 3 tháng miễn phí sau bàn giao.
          </p>
          <a href="/contact" className={cx('cta-button-large')}>
            Nhận Báo Giá Miễn Phí
          </a>
          <div className={cx('contact-info')}>
            <p>Email: info@yourcompany.com</p>
            <p>Hotline: 0123 456 789</p>
          </div>
        </div>
      </section>

      {/* Simple Footer */}
      <footer className={cx('footer')}>
        <p>&copy; 2025 Your Company. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default WebsiteService;